import { TextArea } from './TextArea'
import { withTextArea } from './withTextArea'

const ConnectedTextArea = withTextArea(TextArea)

export { ConnectedTextArea as TextArea }
